import { Coverage } from '../../../../../../../Typescript/classes';

/**
 * Is this coverage a property coverage? Quite fragile right now as the name of the property coverages may change at some point.
 */
export const isPropertyCoverage = (coverage: Coverage): boolean => {
  return !!coverage.name.match(/^property/i);
};
